import * as React from 'react';

function MobileMenuBackButton(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M15 18L9 12L15 6" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default MobileMenuBackButton;
